import { render, staticRenderFns } from "./UserValaszto.vue?vue&type=template&id=0ff2e608&scoped=true&"
import script from "./UserValaszto.vue?vue&type=script&lang=js&"
export * from "./UserValaszto.vue?vue&type=script&lang=js&"
import style0 from "./UserValaszto.vue?vue&type=style&index=0&id=0ff2e608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff2e608",
  null
  
)

export default component.exports